import React, { Component } from 'react';
import { signOff } from '../../../Utilities/SnsExtranetFunctions';
import { getTranslation } from '../../../Utilities/GetTranslation';

class ExtranetSignOut extends Component {
    constructor(props) {
        super(props);

        this.exit = this.exit.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    exit() {
        signOff();
        window.location = "/login";
    }

    cancel() {
        window.history.back();
    }

    render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="ebadge text-center">
                            <h3>{getTranslation("sns.general.extranet.signoff")}</h3>
                            <div className="button-wrapper">
                                <a className="FormButton btn btn-primary blue" onClick={this.exit}>{getTranslation("sns.general.yes")}</a>
                                <a className="FormButton btn btn-primary blue" onClick={this.cancel}>{getTranslation("sns.general.no")}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ExtranetSignOut;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ExtranetSignOut.js